<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .profile-card-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .avatar-group {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: utils.in_rem(8px);
    }
  }
</style>

<script>
  // Stores
  import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store";
  import { avatarProps, todosModalItemStore } from "../stores";
  // Components
  import Avatar from "@sourcewhale/shared/svelte-design-system/components/atoms/Avatar.svelte";
  import StatusTag from "@sourcewhale/shared/svelte-design-system/components/atoms/TagsAndChips/StatusTag.svelte";
  import CVSection from "./CVSection.svelte";
</script>

<div class="profile-card-header">
  <div class="avatar-group">
    <Avatar {...$avatarProps} size="large" />
    {#if $todosModalItemStore?.callBackLaterTimestamp}
      <StatusTag kind="warning" contrast="low" size="medium">
        Call back later
      </StatusTag>
    {/if}
  </div>
  {#if $userStore.hasCrm}
    <CVSection />
  {/if}
</div>
